export type ErrorType = {
    message: string
};

export type CustonValidationType = (value: string) => boolean;

export const validatorForm = (event: any, error: ErrorType[], setError: (props: any) => void, customMessage : string | null = null, customValidate : null | CustonValidationType = null) => {
    customMessage = customMessage || "Este campo event obrigatorio!";
    let isValid = !!event.target.value;
    if (typeof customValidate === 'function') {
        isValid = customValidate(event.target.value);
    }
    if (!isValid){
        setError({...error, [event.target.name]: {message: customMessage}})
    }else{
        const tempError = {...error};
        delete tempError[event.target.name];
        setError(tempError)
    }
}

export function isValidEmail(emailAdress: string){
    const regex: RegExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (emailAdress.match(regex))
        return true;
    else
        return false;
}

export function isValidCPF(value: string) {
    value = value.replace(/[^\d]+/g, '');

    if (value.length !== 11 || !!value.match(/(\d)\1{10}/)) {
        return false;
    }

    const values = value.split('').map(el => +el);
    const rest = (count: number) => (values.slice(0, count-12).reduce( (soma, el, index) => (soma + el * (count-index)), 0 )*10) % 11 % 10;

    return rest(10) === values[9] && rest(11) === values[10];
}